import { css } from 'lit';

export const aboutViewStyles = css`
  :host {
    display: block;
  }

  .about-container {
    font-size: 1.05rem;
    line-height: 1.7;
    color: var(--text-primary, #1a1a18);
  }

  p {
    margin-bottom: 1.25rem;
    color: var(--text-primary, #1a1a18);
  }

  .history-section {
    margin-top: 2rem;
    border-top: 1px dashed var(--border-color, #e5e5de);
    padding-top: 1.5rem;
  }

  h3 {
    font-family: var(--font-serif, serif);
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--text-primary, #1a1a18);
    margin-bottom: 1rem;
  }

  .history-list {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
  }

  .history-item {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 1rem;
    align-items: baseline;
    font-size: 0.95rem;
  }

  .history-time {
    font-family: var(--font-mono, monospace);
    font-size: 0.82rem;
    color: var(--text-muted, #7c7c75);
  }

  .history-role {
    font-weight: 600;
    color: var(--text-primary, #1a1a18);
  }

  .history-org {
    color: var(--accent-color, #245590);
  }

  .history-desc {
    font-size: 0.88rem;
    color: var(--text-secondary, #4a4a45);
    margin-top: 0.15rem;
  }

  a {
    color: var(--accent-color, #245590);
    text-decoration: none;
    border-bottom: 1px solid var(--border-color, #e5e5de);
    transition: all 0.15s ease;
  }

  a:hover {
    color: var(--accent-hover, #173760);
    border-bottom-color: var(--accent-color, #245590);
  }

  @media (max-width: 550px) {
    .history-item {
      grid-template-columns: 1fr;
      gap: 0.2rem;
    }
  }
`;
